import { useCallback, useState } from "react";
import type { RoleLevel, RoleLevelPreference } from "../types/job";
import {
  persistRoleLevelPreference,
  readRoleLevelPreference,
} from "../lib/roleLevel";

/**
 * `null` means the user has not completed onboarding (no value in localStorage yet).
 * After onboarding, value is always set (one of RoleLevel or "all" if they widened in filters).
 */
export function useRoleLevelPreference() {
  const [preference, setPreferenceState] = useState<RoleLevelPreference | null>(
    () => (typeof window === "undefined" ? null : readRoleLevelPreference()),
  );

  const setPreference = useCallback((value: RoleLevelPreference) => {
    setPreferenceState(value);
    persistRoleLevelPreference(value);
  }, []);

  const completeOnboarding = useCallback(
    (level: RoleLevel) => {
      setPreference(level);
    },
    [setPreference],
  );

  return {
    preference,
    needsOnboarding: preference === null,
    setPreference,
    completeOnboarding,
  };
}
